import React from 'react';

import { ChangeHandler } from 'src/presentation/components/pages/integrations/types';
import CompactSection from 'src/presentation/components/pages/integrations/editorComponents/CompactSection';
import { Row } from 'src/presentation/components/forms/Layout';
import {
  MaskedField,
  WrappedField,
} from 'src/presentation/components/pages/integrations/editorComponents/EditorFields';

function renderBigCommerceConfiguration(
  onChange: (attr: string) => ChangeHandler,
  maskedFields: string[]
): JSX.Element {
  return (
    <>
      <CompactSection
        description={`The BigCommerce app enriches your customer pages with customer details 
        and order information pulled from your BigCommerce instance. In addition, this 
        app allows agents to perform quick actions (like processing returns) 
        right in Gladly.`}
      >
        <Row>
          <WrappedField
            attr="name"
            label="Name"
            placeholder="App Name"
            description="This is the name that will be displayed throughout Gladly"
            data-aid="bigcommerce-integration-name"
            autoFocus={true}
            onChange={onChange('name')}
          />
        </Row>
        <Row>
          <WrappedField
            attr="connectionSettings.storeHash"
            label="Store Hash"
            description="A unique identifier for your store, which can be found in the URLs assigned to your store by BigCommerce."
            data-aid="bigcommerce-store-hash"
            onChange={onChange('connectionSettings.storeHash')}
          />
        </Row>
        <Row>
          <WrappedField
            attr="connectionSettings.clientId"
            label="Client ID"
            description="A unique identifier for the Gladly App, which is created in your BigCommerce Manager."
            data-aid="bigcommerce-client-id"
            onChange={onChange('connectionSettings.clientId')}
          />
        </Row>
        <Row>
          <MaskedField
            attr="secrets.token"
            label="Access Token"
            showClearButton={maskedFields.includes('token')}
            isMasked={maskedFields.includes('token')}
            data-aid="bigcommerce-token"
            onChange={onChange('secrets.token')}
          />
        </Row>
      </CompactSection>
    </>
  );
}

export default renderBigCommerceConfiguration;
